import{a as w}from"./ids-chunk-U4K5B3VN.js";import{a as E,b as A}from"./ids-chunk-XE4WFW5M.js";import{a as x}from"./ids-chunk-W3LDHTW6.js";import{e as b}from"./ids-chunk-Y6KVKFJX.js";import{a as o}from"./ids-chunk-TFRXZ5TN.js";import{a as y,b as c,c as d,d as h,f as r}from"./ids-chunk-ZMMCFAAI.js";var M=`/* Ids Breadcrumb Component */
.ids-breadcrumb {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  align-items: center;
  display: flex;
  width: 100%;
}
.ids-breadcrumb [text-decoration] {
  text-decoration: attr(text-decoration);
}
.ids-breadcrumb-menu {
  position: relative;
}
.ids-breadcrumb-menu::after {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--ids-breadcrumb-color-text-default);
  content: "/";
  font-weight: var(--ids-breadcrumb-font-weight);
  padding-right: var(--ids-space-2xs);
  padding-left: var(--ids-space-none);
  text-decoration: none;
  display: inline-block;
  vertical-align: top;
  margin-top: 10px;
}
.ids-breadcrumb.can-truncate {
  white-space: nowrap;
}
.ids-breadcrumb.can-truncate nav {
  display: flex;
  position: relative;
  justify-content: end;
  overflow: hidden;
}
.ids-breadcrumb nav {
  padding: var(--ids-space-xs);
}
.ids-breadcrumb nav.truncate::before {
  transition: width var(--ids-motion-duration) var(--ids-motion-ease), background var(--ids-motion-duration) var(--ids-motion-ease);
  background-color: var(--ids-color-transparent);
  background-image: var(--ids-breadcrumb-gradient);
  content: "";
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  z-index: var(--ids-z-index-10);
  width: var(--ids-size-40);
}
.ids-breadcrumb.color-variant-breadcrumb .ids-breadcrumb-menu::after {
  color: var(--ids-breadcrumb-color-text-default);
}
.ids-breadcrumb.color-variant-breadcrumb nav.truncate::before {
  color: var(--ids-breadcrumb-color-text-default);
}
.ids-breadcrumb.color-variant-alternate .ids-breadcrumb-menu::after {
  color: var(--ids-breadcrumb-color-text-emphasis);
}
.ids-breadcrumb.color-variant-alternate nav.truncate::before {
  color: var(--ids-breadcrumb-color-text-emphasis);
  background-image: linear-gradient(to right, var(--ids-header-gradient-opacity-none), var(--ids-header-gradient-opacity-full));
}

a.ids-hyperlink,
span.ids-breadcrumb-divider {
  font-size: var(--ids-breadcrumb-font-size);
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  color: var(--ids-breadcrumb-color-text-default);
  margin-inline-end: 0;
}
a.ids-hyperlink:not(.ids-hyperlink-color-unset):not([mode]),
span.ids-breadcrumb-divider:not(.ids-hyperlink-color-unset):not([mode]) {
  color: var(--ids-breadcrumb-color-text-default);
}

::slotted(*),
.ids-breadcrumb > * {
  display: inline-block;
}

::slotted(*:not(:first-child))::before,
span.ids-breadcrumb-divider:not(:first-child)::before {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: var(--ids-breadcrumb-font-size);
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  color: inherit;
  content: "/";
  font-weight: normal;
  padding: var(--ids-space-4xs) var(--ids-space-xs);
  text-decoration: none;
  display: inline-block;
  margin-inline-start: -3px;
  vertical-align: top;
}

.hidden {
  display: none;
}`;var L=w(x),s,e,I,D,S,T,m,p,f,u,k,g,v,a=class extends L{constructor(){super();h(this,e);c(this,"onBreadcrumbActivate");h(this,s,new ResizeObserver(()=>this.resize()));c(this,"colorVariants",["breadcrumb","alternate"])}connectedCallback(){super.connectedCallback(),this.setAttribute("role","navigation"),this.setAttribute("aria-label","Breadcrumb"),r(this,e,I).call(this),this.truncate&&r(this,e,u).call(this),r(this,e,v).call(this),r(this,e,g).call(this)}static get attributes(){return[...super.attributes,o.PADDING,o.TRUNCATE]}resize(){return r(this,e,m).call(this),this}template(){return`
      <div class="ids-breadcrumb${this.truncate?" truncate":""}">
        <div class="ids-breadcrumb-menu hidden">
          <ids-menu-button id="icon-button" menu="icon-menu">
            <ids-icon icon="more"></ids-icon>
            <span class="audible">Icon Only Button</span>
          </ids-menu-button>
          <ids-popup-menu id="icon-menu" target="#icon-button" trigger-type="click">
            <ids-menu-group>
            </ids-menu-group>
          </ids-popup-menu>
        </div>
        <nav part="breadcrumb">
          <slot></slot>
        </nav>
      </div>`}get current(){return this.querySelector('[font-weight="semibold"]')}get buttonEl(){return this.container?.querySelector("ids-menu-button")}get menuContainerEl(){return this.container?.querySelector(".ids-breadcrumb-menu")}get navElem(){return this.container?.querySelector("nav")}get overflowMenuItems(){return this.popupMenuGroupEl?[...this.popupMenuGroupEl.children]:[]}get popupMenuEl(){return this.container?.querySelector("ids-popup-menu")}get popupMenuGroupEl(){return this.container?.querySelector("ids-menu-group")}set truncate(t){let i=this.truncate,n=b(t);i!==n&&(n?(this.setAttribute(o.TRUNCATE,String(t)),r(this,e,u).call(this)):(this.removeAttribute(o.TRUNCATE),r(this,e,k).call(this)))}get truncate(){return b(this.getAttribute(o.TRUNCATE))}set padding(t){t?(this.container?.style.setProperty("padding",`0 ${t}px`),this.setAttribute(o.PADDING,t.toString())):this.removeAttribute(o.PADDING)}get padding(){return this.getAttribute(o.PADDING)}isOverflowed(t){if(!this.contains(t)||t.hidden)return!1;let i=t.getBoundingClientRect(),n=this.navElem?.getBoundingClientRect(),l=i.right>(n?.right||NaN);return i.left<(n?.left||NaN)||l}refreshOverflowedItems(){this.overflowMenuItems.forEach(t=>{let i=!this.isOverflowed(t.overflowTarget);t.hidden=i,i?t.overflowTarget?.removeAttribute(o.OVERFLOWED):t.overflowTarget?.setAttribute(o.OVERFLOWED,"")}),this.menuContainerEl?.setAttribute(o.HIDDEN,String(!this.hasVisibleActions())),this.buttonEl?.setAttribute(o.HIDDEN,String(!this.hasVisibleActions())),this.buttonEl?.setAttribute(o.DISABLED,String(!this.hasEnabledActions()))}hasVisibleActions(){return!!this.container?.querySelectorAll("ids-menu-group > ids-menu-item:not([hidden])").length}hasEnabledActions(){return!!this.container?.querySelectorAll("ids-menu-group > ids-menu-item:not([disabled])").length}};s=new WeakMap,e=new WeakSet,I=function(){this.onEvent("click",this,t=>{t.target.tagName==="IDS-HYPERLINK"&&typeof this.onBreadcrumbActivate=="function"&&this.current&&t.target!==this.current&&this.onBreadcrumbActivate(t.target,this.current)}),this.onEvent("slotchange",this.container,()=>{r(this,e,v).call(this),r(this,e,g).call(this),this.truncate&&(r(this,e,u).call(this),r(this,e,m).call(this))}),this.onEvent("beforeshow",this.popupMenuEl,t=>{this.triggerEvent("beforeshow",this,{bubbles:t.bubbles,detail:t.detail}),this.refreshOverflowedItems()}),this.onEvent("selected",this.popupMenuEl,t=>{this.triggerEvent("beforeshow",this,{bubbles:t.bubbles,detail:t.detail}),t.target.overflowTarget&&typeof this.onBreadcrumbActivate=="function"&&this.current&&this.onBreadcrumbActivate(t.target.overflowTarget,this.current)})},D=function(){let t=this.popupMenuGroupEl,i=[...this.children].map(r(this,e,S)).join("");t?.insertAdjacentHTML("afterbegin",i),this.overflowMenuItems.forEach((n,l)=>{n.overflowTarget=this.children[l]})},S=function(t){let i=t.hasAttribute(o.DISABLED)?" disabled":"",n=t.hasAttribute(o.HIDDEN)?" hidden":"";return`<ids-menu-item${i}${n}>${t.textContent}</ids-menu-item>`},T=function(){this.popupMenuGroupEl&&(this.popupMenuGroupEl.innerHTML="")},m=function(){this.refreshOverflowedItems(),this.hasVisibleActions()?r(this,e,p).call(this):r(this,e,f).call(this)},p=function(){this.buttonEl?.removeAttribute("hidden"),this.menuContainerEl?.classList.remove(o.HIDDEN),this.container?.classList.add("truncate"),this.container?.querySelector("nav")?.classList.add("truncate")},f=function(){this.buttonEl?.setAttribute("hidden",""),this.menuContainerEl?.classList.add(o.HIDDEN),this.container?.classList.remove("truncate"),this.container?.querySelector("nav")?.classList.remove("truncate")},u=function(){d(this,s).disconnect(),this.container&&d(this,s).observe(this),r(this,e,D).call(this),r(this,e,p).call(this),this.container?.classList.add("can-truncate")},k=function(){d(this,s).disconnect(),r(this,e,f).call(this),r(this,e,T).call(this),this.container?.classList.remove("can-truncate")},g=function(){this.querySelectorAll("ids-hyperlink").forEach(t=>{let i=t;i.fontSize="14",i.textDecoration=i.textDecoration==="none"?"none":"hover",i.colorVariant="breadcrumb"})},v=function(t,i){let n=t;this.contains(n)||(n=this.lastElementChild),i||(i=this.querySelector('[font-weight="semibold"]')),i&&(i.fontWeight=null,i.textDecoration=null,n.shadowRoot.querySelector("a").style.pointerEvents="none"),n&&(n.disabled=!1,n.fontWeight="semibold",n.fontSize=14,n.textDecoration="none",n.shadowRoot.querySelector("a").style.pointerEvents="none")},a=y([E("ids-breadcrumb"),A(M)],a);export{a};
